// KPI paket AI önerisi — istek / model çıktısı / yanıt zarfı (spec 2026-11-02-kpi-paket-ui-ai-oneri-design).

import { z } from "zod";

export const KPI_PACKAGE_SUGGEST_NOTE_MAX = 500;

const Uuid = z.string().uuid();

export const KpiPackageSuggestRequestSchema = z.object({
  note: z.string().trim().max(KPI_PACKAGE_SUGGEST_NOTE_MAX).optional(),
});
export type KpiPackageSuggestRequest = z.infer<typeof KpiPackageSuggestRequestSchema>;

/** LLM'in döndürdüğü ham çıktı — kodlar sunucuda katalogla doğrulanır. */
export const KpiPackageSuggestModelOutputSchema = z.object({
  suggestions: z.array(z.object({ code: z.string(), reason: z.string() })),
});
export type KpiPackageSuggestModelOutput = z.infer<typeof KpiPackageSuggestModelOutputSchema>;

export const KpiPackageSuggestResponseSchema = z.object({
  suggestions: z.array(z.object({ metricId: Uuid, code: z.string(), reason: z.string() })),
  autoAdded: z.array(
    z.object({
      metricId: Uuid,
      because: z.object({ kind: z.enum(["formula", "breakdown"]), ofMetricId: Uuid }),
    }),
  ),
  alreadyInPackage: z.array(Uuid),
  dropped: z.number().int().nonnegative(),
});
export type KpiPackageSuggestResponse = z.infer<typeof KpiPackageSuggestResponseSchema>;
